import React, { useEffect, useState } from 'react';
import './contactUsBmu.scss';

function contactUsBmu({ showContactUs, setShowContactUs }) {
  const [isClassAdded, setIsClassAdded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsClassAdded(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {showContactUs && (
        <div className='contact-us-modal'>
          <div className='contact-us-modal__title'>
            <div className='contact-us-modal__title-text'>Contact Us</div>
            <span
              class='material-symbols-outlined contact-us-modal__title-text point-me-daddy'
              onClick={() => setShowContactUs(false)}
            >
              close
            </span>
          </div>
          <div className='contact-us-modal__base'>
            <div className='contact-us-modal__base-item'>
              <div className='contact-us-modal__base-label'>
                <span class='material-symbols-outlined'>call</span>
                <div className='contact-us-modal__label-text'>
                  Helpline Number
                </div>
              </div>
              <div className='contact-us-modal__base-value'>+9191919191</div>
            </div>
            <div className='contact-us-modal__base-item'>
              <div className='contact-us-modal__base-label'>
                <span class='material-symbols-outlined'>mail</span>
                <div className='contact-us-modal__label-text'>Email ID</div>
              </div>
              <div className='contact-us-modal__base-value'>
                loremipsum@herovired.com
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className={`contact-us-bmu ${isClassAdded ? 'in-view' : ''}`}
        onClick={() => {
          setShowContactUs(!showContactUs);
          window.FreshworksWidget('close');
        }}
      >
        <span class='material-symbols-outlined contact-us-bmu__text'>call</span>
        <div className='contact-us-bmu__text'>Contact Us</div>
      </div>
    </>
  );
}

export default contactUsBmu;
